import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-linkedin-auth',
  templateUrl: './linkedin-auth.component.html',
  styleUrls: ['./linkedin-auth.component.scss']
})
export class LinkedinAuthComponent implements OnInit {

  constructor(private route: ActivatedRoute,
  ) {

  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      let code = params['code'];
      window.opener.postMessage({ 'type': 'code', 'code': code }, location.origin)
      window.close();
    });
  }

}
